// RegExpRoute.jsx
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

import { removeLangFromPath } from '../resource/langPath.js';

const DEFAULT_REG_EXP = /.*/;

export const RegExpRoute = ({
  regExp = DEFAULT_REG_EXP,
  element,
  shouldRemoveLang = false,
}) => {
  const location = useLocation();
  const pathname = shouldRemoveLang
    ? removeLangFromPath(location.pathname)
    : location.pathname;

  if (regExp.test(pathname)) {
    return element;
  } else {
    return null;
  }
};

RegExpRoute.propTypes = {
  element: PropTypes.element.isRequired,
  regExp: PropTypes.object,
  shouldRemoveLang: PropTypes.bool,
};

export default RegExpRoute;
